// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart1_first__1ZLzT","second":"Chart1_second__2Wcd-","third":"Chart1_third__2uTDA"};